<template>
  <div class="question">
    <component
      v-for="(answer, index) in question.answers"
      ref="answers"
      :key="answer.id"      
      :is="answer.answer_type"
      :answer="answer"
      :answer-index="index"
      :init-value="answer.value"
      :is-selected-answer="selectedAnswerId === answer.id"
      :force-highlighted="forceHighlighting"
      :effected-warning-enabled="effectedWarningEnabled"
      :required="question.required"
      @selectAnswer="setSelectedAnswer"
      @valueChanged="questionValueChanged"
    />
  </div>
</template>
<style lang="scss">
.list-enter-active, .list-leave-active {
  transition: all 1s;
}
.list-enter, .list-leave-to /* .list-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateY(30px);
}
</style>
<script>
    import { indexOf, findIndex, forEach, isNull } from 'lodash'
    import Placeholder from './answers/Placeholder.vue'
    import Number from './answers/Number.vue'
    import Slider from './answers/Slider.vue'
    import Click from './answers/Click.vue'
    import Word from './answers/Word.vue'
    import Radio from './answers/Radio.vue'
    
    export default {
        name: "Question",
        components: {
            'input-number': Number,
            'input-word': Word,
            'radio': Radio,
            'placeholder': Placeholder,
            'slider': Slider,
            'click': Click
        },
        props: {
            'question': {
                type: Object,
                required: true
            }
        },
        data: function() { return {
            selectedAnswerId: this.question.selected_answer
        }},
        computed: {
            selectedAnswerIndex: function() {
                if(!isNull(this.selectedAnswerId) && this.selectedAnswerId > 0) {
                    return findIndex(this.question.answers, ['id', this.selectedAnswerId])
                }
                
                return null
            },
            selectedAnswer: function() {
                if(isNull(this.selectedAnswerIndex)) {
                    return null
                }

                return this.$refs.answers[this.selectedAnswerIndex]
            },
            forceHighlighting: function() {
                //
                if(this.question.inherit_active_highlighting === null) { return null }
                let status = false

                //for questions that are not used in this group
                if(this.question.inherit_active_highlighting.global) {
                    forEach(this.question.inherit_active_highlighting.global, (question) => {
                        if(question.value > 0) {
                            status = true
                            return false
                        }
                    })
                }

                //for all questions in this group
                if(this.question.inherit_active_highlighting.local) {
                    forEach(this.question.inherit_active_highlighting.local, (question) => {
                        if(indexOf(this.$store.colorizedQuestions, question.question_id) >= 0) {
                            status = true
                            return false
                        }
                    })
                }                

                return status
            },
            effectedWarningEnabled: function() {
                if(this.$store.page.changeWarningEnabled && this.question.hasEffects) {
                    return true
                }

                return false                
            }
        },
        created() {
            Vue.set(this.$store.rdyToSend, 'Q'+this.question.id)
        },
        beforeDestroy() {
            Vue.delete(this.$store.rdyToSend, 'Q'+this.question.id)
        },
        mounted() {
            this.isRdyToSend()
            if(this.question.inherit_active_highlighting === null) { return null }
        },
        methods: {
            setSelectedAnswer(payload) {
                if(this.selectedAnswerId !== payload.answerId) {
                    this.selectedAnswerId = payload.answerId
                    this.questionValueChanged()
                }
            },
            questionValueChanged() {
                this.isRdyToSend()
                this.$event.$emit('calculation-changed')
            },
            isRdyToSend() {
                if(this.$store.debug && this.$store.debug.ignoreRdyToSend) {
                    this.$store.rdyToSend['Q' + this.question.id] = true
                    return false
                }

                if(this.question.stop_continue) {
                    this.$store.rdyToSend['Q' + this.question.id] = false
                    return false
                }

                if(this.selectedAnswer && this.selectedAnswer.isValid) {
                    this.$store.rdyToSend['Q' + this.question.id] = true
                } else {
                    this.$store.rdyToSend['Q' + this.question.id] = false
                }
            },
            getResponseData() {
                if(this.$store.debug.ignoreRdyToSend) {
                    return false
                }
                
                if(this.selectedAnswer.answer.answer_type === 'placeholder') {
                    return false
                }

                if(this.effectedWarningEnabled) {
                    return false
                }

                return {
                    question_id: this.question.id,
                    answer_id: this.selectedAnswerId,
                    value: this.selectedAnswer.value
                }
            }            
        },
    }
</script>
